/**
 * Utilty class for getting current time. Use `Time.now()` instead of
 * `new Date()` if you want to test time dependent feature locally.
 */
export default class Time {
  private static instance: Time

  private offset?: number

  static getInstance(): Time {
    if (!Time.instance) {
      Time.instance = new Time()
      Time.syncNow()
    }
    return Time.instance
  }

  static setNow(date: Date) {
    const instance = Time.getInstance()
    instance.offset = date.getTime() - new Date().getTime()
  }

  /**
   * Set client's current time same as the server's current time
   */
  static syncNow() {
    // prevent undefined fetch in jest
    if (window.fetch == null) {
      return
    }

    fetch('/api/time')
      .then(res => res.text())
      .then(datetimeString => Time.setNow(new Date(datetimeString)))
      .catch(console.error)
  }

  static now() {
    const now = new Date()
    const instance = Time.getInstance()
    return instance.offset ? new Date(now.getTime() + instance.offset) : now
  }
}
